if (!customElements.get('koeed-gallery-cart')) {
  customElements.define('koeed-gallery-cart', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.variant = this.form.elements.id;
      this.quantity = this.form.elements.quantity;
      this.button = this.form.querySelector('button');
      this.message = this.querySelector('[data-message]');
      this.variant.addEventListener('change', () => {
        const option = this.variant.selectedOptions[0];
        this.querySelector('[data-price]').textContent = option.dataset.price;
        this.quantity.min = option.dataset.min;
        this.quantity.step = option.dataset.step;
        if (option.dataset.max) this.quantity.max = option.dataset.max;
        else this.quantity.removeAttribute('max');
        this.quantity.value = option.dataset.min;
        this.message.textContent = '';
      }, { signal: this.events.signal });
      this.form.addEventListener('submit', event => this.add(event), { signal: this.events.signal });
    }
    disconnectedCallback() { this.events?.abort(); }
    async add(event) {
      event.preventDefault();
      if (this.busy || !this.form.reportValidity()) return;
      this.busy = true;
      const label = this.button.textContent;
      const body = new FormData(this.form);
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const sections = cart?.getSectionsToRender?.() || [{ id: 'cart-icon-bubble' }];
      body.append('sections', sections.map(section => section.id).join(','));
      body.append('sections_url', location.pathname);
      cart?.setActiveElement?.(this.button);
      this.button.disabled = true;
      this.variant.disabled = true;
      this.quantity.disabled = true;
      this.button.textContent = this.dataset.adding;
      this.message.textContent = '';
      this.querySelector('[data-cart-link]').hidden = true;
      let added = false;
      try {
        const response = await fetch(this.form.action, { method: 'POST', body, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
        added = true;
        this.message.textContent = this.dataset.added;
        this.querySelector('[data-cart-link]').hidden = false;
        // A failed section refresh must never turn a successful add into a retry prompt.
        if (cart?.renderContents && sections.every(section => result.sections?.[section.id])) {
          cart.classList.remove('is-empty');
          cart.renderContents(result);
        } else if (result.sections?.['cart-icon-bubble']) {
          const incoming = new DOMParser().parseFromString(result.sections['cart-icon-bubble'], 'text/html');
          const bubble = document.querySelector('#cart-icon-bubble');
          const content = incoming.querySelector('.shopify-section');
          if (bubble && content) bubble.innerHTML = content.innerHTML;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gallery-cart', productVariantId: body.get('id'), cartData: result });
        }
      } catch (error) {
        if (!added) this.message.textContent = error instanceof TypeError ? this.dataset.error : error.message;
      } finally {
        this.busy = false;
        this.button.disabled = false;
        this.variant.disabled = false;
        this.quantity.disabled = false;
        this.button.textContent = label;
      }
    }
  });
}
